/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, type RequestExtraParams, request } from '@/utils/request'
import type {
  DemoPostData,
  DemoPostPayload,
  SeaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGetData,
  SeaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGetParams,
  SeaOctopusApiCommonPlatformSwitchPostData,
  SeaOctopusApiCommonPostMedusaPostData,
  SeaOctopusApiCommonPostMedusaPostPayload,
  SeaOctopusApiCommonRouteConfigPostData,
  SeaOctopusApiCommonWcxWebviewBasePostData,
  SeaOctopusApiItranplatapiResourceListPostData,
  SeaOctopusApiItranplatapiResourceListPostPayload,
  SeaOctopusApiLbsLocationPostData,
  SeaOctopusApiLbsLocationPostPayload,
  SeaTurtleApiAppConfigAllPostData,
  SeaTurtleApiAreaCodeGetDefaultPostData,
  SeaTurtleApiAreaCodeGetDefaultPostPayload,
  SeaTurtleApiAppVersionInfoLatestVersionInfoPostData,
  SeaTurtleApiClauseInfoAllPostData,
  SeaTurtleApiClauseInfoAgreementTypeListPostData,
  SeaTurtleApiClauseInfoAgreementTypeListPostPayload,
  SeaTurtleApiClauseInfoGetByConditionPostData,
  SeaTurtleApiClauseInfoGetByConditionPostPayload,
  SeaTurtleApiClauseInfoGetByTypePostData,
  SeaTurtleApiClauseInfoGetByTypePostPayload,
  SeaTurtleApiCountryAndLanguageAllPostData,
  SeaTurtleApiCountryAndLanguageEnableListPostData,
  SeaTurtleApiCountryAndLanguageGetLanguageInfoPostData,
  SeaTurtleApiCountryAndLanguageGetLanguageInfoPostPayload,
  SeaTurtleApiCountryAndLanguageGetTopCountryPostData,
  SeaTurtleApiCountryAndLanguageGetTopCountryPostPayload,
  SeaTurtleApiCountryAndLanguageGroupPostData,
  SeaTurtleApiCountryCountryRegionAllPostData,
  SeaTurtleApiCountryCountryRegionPostData,
  SeaTurtleApiGraphVerifyConfigGetClientSwitchByScenePostData,
  SeaTurtleApiGraphVerifyConfigGetClientSwitchByScenePostPayload,
  SeaTurtleApiHolidayListPostData,
  SeaTurtleApiHolidayListPostPayload,
} from './data-contracts'

export type { ParamData, ReturnPromise } from '@/utils/request'

const baseUrl: string = '/sea_shell'

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiAppVersionInfoLatestVersionInfoPost
 * @summary App最新版本信息
 * @request POST:/sea_turtle_api/appVersionInfo/latestVersionInfo
 */
export function seaTurtleApiAppVersionInfoLatestVersionInfoPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiAppVersionInfoLatestVersionInfoPostData, any>({
    url: baseUrl + `/sea_turtle_api/appVersionInfo/latestVersionInfo`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 请求参数：{   "longitude":"101.65570349852025",   "latitude":"3.2177996242281575"}返回结果{   "status":200,   "message":"请求成功",   "body": {       "intlCountryFlag":**true**,       "country":"日本",       "province":"群马县",       "city":"嬬恋村",       "district":"[]",       "name":"",       "address":"Nihon Romantic Highway, 嬬恋村, Agatsuma-gun, 群马县, 日本",       "cityId":"",       "euCityId":"",       "adCode":"[]",       "twoCode":"",       "cityCode":"",       "ecityId":""    }}
 *
 * @tags CommonApi
 * @name SeaOctopusApiLbsLocationPost
 * @summary 逆地址
 * @request POST:/sea_octopus_api/lbs/location
 */
export function seaOctopusApiLbsLocationPost(
  root: SeaOctopusApiLbsLocationPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaOctopusApiLbsLocationPostData, any>({
    url: baseUrl + `/sea_octopus_api/lbs/location`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaOctopusApiCommonWcxWebviewBasePost
 * @summary 获取wcxWebviewBase配置信息
 * @request POST:/sea_octopus_api/common/wcxWebviewBase
 */
export function seaOctopusApiCommonWcxWebviewBasePost(data?: any, params: RequestExtraParams = {}) {
  return request<SeaOctopusApiCommonWcxWebviewBasePostData, any>({
    url: baseUrl + `/sea_octopus_api/common/wcxWebviewBase`,
    method: 'POST',
    data: data,
    contentType: ContentType.FormData,
    ...params,
  })
}

/**
 * @description {   "status":200,   "message":"Request Success",   "body":"{\n    "flight": [\n        {\n            "imgUrl": "[https://file.40017.cn/international/pc/common/img/m-frame-en.png",\n](https://file.40017.cn/international/pc/common/img/m-frame-en.png&quot;,%5Cn)            "linkUrl": "[https://www.hopegoo.com/m/en-my"\n](https://www.hopegoo.com/m/en-my&quot;%5Cn)        }\n    ],\n    "hotel": [\n        {\n            "imgUrl": "[https://file.40017.cn/international/pc/common/img/m-frame-en.png",\n](https://file.40017.cn/international/pc/common/img/m-frame-en.png&quot;,%5Cn)            "linkUrl": "[https://www.hopegoo.com/m/en-my"\n](https://www.hopegoo.com/m/en-my&quot;%5Cn)        }\n    ],\n    "train": [\n        {\n            "imgUrl": "[https://file.40017.cn/international/pc/common/img/m-frame-en.png",\n](https://file.40017.cn/international/pc/common/img/m-frame-en.png&quot;,%5Cn)            "linkUrl": "[https://www.hopegoo.com/m/en-my"\n](https://www.hopegoo.com/m/en-my&quot;%5Cn)        }\n    ]\n}"}
 *
 * @tags CommonApi
 * @name SeaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGet
 * @summary 运营位
 * @request GET:/sea_octopus_api/common/getIntlMBusinessBannersConfigInfo
 */
export function seaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGet(
  query: SeaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGetParams,
  params: RequestExtraParams = {},
) {
  return request<SeaOctopusApiCommonGetIntlMBusinessBannersConfigInfoGetData, any>({
    url: baseUrl + `/sea_octopus_api/common/getIntlMBusinessBannersConfigInfo`,
    method: 'GET',
    query: query,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaOctopusApiCommonPlatformSwitchPost
 * @summary 平台开关
 * @request POST:/sea_octopus_api/common/platformSwitch
 */
export function seaOctopusApiCommonPlatformSwitchPost(data?: any, params: RequestExtraParams = {}) {
  return request<SeaOctopusApiCommonPlatformSwitchPostData, any>({
    url: baseUrl + `/sea_octopus_api/common/platformSwitch`,
    method: 'POST',
    data: data,
    contentType: ContentType.FormData,
    ...params,
  })
}

/**
 * @description Response 数据结构：{"code":10000,"msg":"ok","data":{"front":[{"language":"ja-jp","layout":"front","mainlandUrl":"[https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/ja\-jp/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/ja\-jp/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"de\-de"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-de/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-de/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"de\-at"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-at/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-at/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"de\-ch"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-ch/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/de\-ch/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-au"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-au/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-au/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-sg"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-sg/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-sg/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-ph"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-ph/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-ph/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-hk"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-hk/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-hk/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-nz"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-nz/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-nz/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"zh\-tw"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-tw/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-tw/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-gb"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-gb/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-gb/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-ca"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-ca/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-ca/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-in"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-in/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-in/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-my"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-my/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-my/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"zh\-cn"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-cn/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-cn/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"zh\-hk"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-hk/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/zh\-hk/1\.0\.1/language\.json"\,"version":"1\.0\.1"\}\,\{"language":"en\-us"\,"layout":"front"\,"mainlandUrl":"https://oss\.17usoft\.com/inter\-server/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-us/1\.0\.1/language\.json"\,"overseaUrl":"http://ap\-southeast\-1\.oss\.17usoft\.com/inter\-language/project\_ce9530827f74454dbc9af168b2925037/standard/product/en\-us/1\.0\.1/language\.json"\,"version":"1\.0\.1](https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/ja-jp/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/ja-jp/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22de-de%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/de-de/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/de-de/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22de-at%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/de-at/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/de-at/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22de-ch%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/de-ch/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/de-ch/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-au%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-au/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-au/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-sg%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-sg/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-sg/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-ph%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-ph/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-ph/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-hk%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-hk/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-hk/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-nz%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-nz/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-nz/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22zh-tw%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-tw/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-tw/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-gb%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-gb/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-gb/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-ca%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-ca/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-ca/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-in%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-in/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-in/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-my%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-my/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-my/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22zh-cn%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-cn/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-cn/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22zh-hk%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-hk/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/zh-hk/1.0.1/language.json%22,%22version%22:%221.0.1%22%7D,%7B%22language%22:%22en-us%22,%22layout%22:%22front%22,%22mainlandUrl%22:%22https://oss.17usoft.com/inter-server/project_ce9530827f74454dbc9af168b2925037/standard/product/en-us/1.0.1/language.json%22,%22overseaUrl%22:%22http://ap-southeast-1.oss.17usoft.com/inter-language/project_ce9530827f74454dbc9af168b2925037/standard/product/en-us/1.0.1/language.json%22,%22version%22:%221.0.1)"}]}}
 *
 * @tags CommonApi
 * @name SeaOctopusApiCommonPostMedusaPost
 * @summary 美杜莎翻译
 * @request POST:/sea_octopus_api/common/postMedusa
 */
export function seaOctopusApiCommonPostMedusaPost(
  root: SeaOctopusApiCommonPostMedusaPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaOctopusApiCommonPostMedusaPostData, any>({
    url: baseUrl + `/sea_octopus_api/common/postMedusa`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name DemoPost
 * @summary demo
 * @request POST:/demo
 */
export function demoPost(root: DemoPostPayload, params: RequestExtraParams = {}) {
  return request<DemoPostData, any>({
    url: baseUrl + `/demo`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 入参：{}返回：{   "status":200,   "message":"Request Success",   "body": {       "config": {           "minTime":"300",           "maxTime":"1800"        },       "list": [            {               "key":"car/home",               "url":"hopegoo://yongche/home",               "preload":"0"            },            {               "key":"flight/home",               "url":"hopegoo://web/home?url=https%3A%2F%2Fapp.hopegoo.com",               "preload":"1"            }        ]    }}
 *
 * @tags CommonApi
 * @name SeaOctopusApiCommonRouteConfigPost
 * @summary 客户端路由配置
 * @request POST:/sea_octopus_api/common/routeConfig
 */
export function seaOctopusApiCommonRouteConfigPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaOctopusApiCommonRouteConfigPostData, any>({
    url: baseUrl + `/sea_octopus_api/common/routeConfig`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiAppConfigAllPost
 * @summary App配置
 * @request POST:/sea_turtle_api/appConfig/all
 */
export function seaTurtleApiAppConfigAllPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiAppConfigAllPostData, any>({
    url: baseUrl + `/sea_turtle_api/appConfig/all`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiAreaCodeGetDefaultPost
 * @summary 获取站点默认区号
 * @request POST:/sea_turtle_api/areaCode/getDefault
 */
export function seaTurtleApiAreaCodeGetDefaultPost(
  root: SeaTurtleApiAreaCodeGetDefaultPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiAreaCodeGetDefaultPostData, any>({
    url: baseUrl + `/sea_turtle_api/areaCode/getDefault`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 请求入参：{}返回结果：{   "status":200,   "message":"Request Success",   "body": [        {           "countryCode":"852",           "twoCode":"HK",           "countryName":"Hong Kong",           "languageList": [                {                   "isValid":1,                   "configUuid":"lccc033200f598b4bf3ace2d8aaeb6b6f02",                   "locale":"zh-hk",                   "countryCode":"",                   "languageName":"繁體中文 (香港)",                   "regionCode":"HK",                   "icon":"flag-fan",                   "language":"HK",                   "currency":"HKD",                   "domain":"",                   "configDesc":"\繁体中文-香港\",                   "imageUrl":"//[file.40017.cn/international/pc/common/img/flag/hant.png](http://file.40017.cn/international/pc/common/img/flag/hant.png)",                   "sortValue":11                },                {                   "isValid":1,                   "configUuid":"lcca5fce4bc36f1407785f8131dccb81d69",                   "locale":"en-hk",                   "countryCode":"",                   "languageName":"English (Hong Kong)",                   "regionCode":"HK",                   "icon":"flag-hk",                   "language":"EN",                   "currency":"HKD",                   "domain":"",                   "configDesc":"",                   "imageUrl":"//[file.40017.cn/international/pc/common/img/flag/hk.png](http://file.40017.cn/international/pc/common/img/flag/hk.png)",                   "sortValue":9                }            ]        }    ]}
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryAndLanguageEnableListPost
 * @summary 国家以及支持的语言列表
 * @request POST:/sea_turtle_api/countryAndLanguage/enableList
 */
export function seaTurtleApiCountryAndLanguageEnableListPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCountryAndLanguageEnableListPostData, any>({
    url: baseUrl + `/sea_turtle_api/countryAndLanguage/enableList`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 入参：{"locale":"zh-hk"}返回：{   "status":200,   "message":"Request Success",   "body": {       "isValid":1,       "configUuid":"lccc033200f598b4bf3ace2d8aaeb6b6f02",       "locale":"zh-HK",       "countryCode":"",       "languageName":"繁體中文 (香港)",       "regionCode":"HK",       "icon":"flag-fan",       "language":"HK",       "currency":"HKD",       "domain":"",       "configDesc":"\繁体中文-香港\",       "imageUrl":"//[file.40017.cn/international/pc/common/img/flag/hant.png](http://file.40017.cn/international/pc/common/img/flag/hant.png)",       "sortValue":1    }}
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryAndLanguageGetLanguageInfoPost
 * @summary 根据locale获取语言
 * @request POST:/sea_turtle_api/countryAndLanguage/getLanguageInfo
 */
export function seaTurtleApiCountryAndLanguageGetLanguageInfoPost(
  root: SeaTurtleApiCountryAndLanguageGetLanguageInfoPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiCountryAndLanguageGetLanguageInfoPostData, any>({
    url: baseUrl + `/sea_turtle_api/countryAndLanguage/getLanguageInfo`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 入参：{   "yearStart":"2023",   "yearEnd":"2023"}返回：{   "status":200,   "message":"请求成功",   "body": [        {           "regionCode":"US",           "date":"2023-01-01",           "name":"New Year's Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-01-02",           "name":"New Year's Day (substitute)",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-01-16",           "name":"Martin Luther King Jr. Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-02-20",           "name":"Presidents' Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-05-29",           "name":"Memorial Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-06-19",           "name":"Juneteenth",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-07-04",           "name":"Independence Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-09-04",           "name":"Labor Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-10-09",           "name":"Columbus Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-11-10",           "name":"Veterans Day (substitute)",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-11-11",           "name":"Veterans Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-11-23",           "name":"Thanksgiving Day",           "type":"1"        },        {           "regionCode":"US",           "date":"2023-12-25",           "name":"Christmas Day",           "type":"1"        }    ]}
 *
 * @tags CommonApi
 * @name SeaTurtleApiHolidayListPost
 * @summary 节假日列表
 * @request POST:/sea_turtle_api/holiday/list
 */
export function seaTurtleApiHolidayListPost(root: SeaTurtleApiHolidayListPostPayload, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiHolidayListPostData, any>({
    url: baseUrl + `/sea_turtle_api/holiday/list`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 入参：{   "projectKey":"app_70001"}返回结果{   "status":200,   "message":"Request Success",   "body": {       "androidList": [            {               "language":"zh-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.6",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/android/zh-hk-1.0.0.6.xml](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/android/zh-hk-1.0.0.6.xml)",                   "overseaUrl":""                }            },            {               "language":"en-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.6",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/android/en-hk-1.0.0.6.xml](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/android/en-hk-1.0.0.6.xml)",                   "overseaUrl":""                }            }        ],       "iosList": [            {               "language":"zh-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.5",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/ios/zh-hk-1.0.0.5.strings](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/ios/zh-hk-1.0.0.5.strings)",                   "overseaUrl":""                }            },            {               "language":"en-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.5",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/ios/en-hk-1.0.0.5.strings](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/ios/en-hk-1.0.0.5.strings)",                   "overseaUrl":""                }            }        ],       "apiList": [            {               "language":"zh-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.1",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/b/zh-hk-1.0.0.1.json](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/b/zh-hk-1.0.0.1.json)",                   "overseaUrl":""                }            },            {               "language":"en-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.1",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/b/en-hk-1.0.0.1.json](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/b/en-hk-1.0.0.1.json)",                   "overseaUrl":""                }            }        ],       "frontList": [            {               "language":"zh-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.4",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/f/zh-hk-1.0.0.4.json](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/f/zh-hk-1.0.0.4.json)",                   "overseaUrl":""                }            },            {               "language":"en-hk",               "urlDetail": {                   "mainlandUrl":"",                   "version":"1.0.0.4",                   "url":"[https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/f/en-hk-1.0.0.4.json](https://oss.17usoft.com/cn-orcastage/all/intlappfront/languages/stage/f/en-hk-1.0.0.4.json)",                   "overseaUrl":""                }            }        ]    }}
 *
 * @tags CommonApi
 * @name SeaOctopusApiItranplatapiResourceListPost
 * @summary 获取多语言资源
 * @request POST:/sea_octopus_api/itranplatapi/resourceList
 */
export function seaOctopusApiItranplatapiResourceListPost(
  root: SeaOctopusApiItranplatapiResourceListPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaOctopusApiItranplatapiResourceListPostData, any>({
    url: baseUrl + `/sea_octopus_api/itranplatapi/resourceList`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryAndLanguageGetTopCountryPost
 * @summary 热门选择国家
 * @request POST:/sea_turtle_api/countryAndLanguage/getTopCountry
 */
export function seaTurtleApiCountryAndLanguageGetTopCountryPost(
  root: SeaTurtleApiCountryAndLanguageGetTopCountryPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiCountryAndLanguageGetTopCountryPostData, any>({
    url: baseUrl + `/sea_turtle_api/countryAndLanguage/getTopCountry`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryAndLanguageAllPost
 * @summary 国家-语言列表
 * @request POST:/sea_turtle_api/countryAndLanguage/all
 */
export function seaTurtleApiCountryAndLanguageAllPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCountryAndLanguageAllPostData, any>({
    url: baseUrl + `/sea_turtle_api/countryAndLanguage/all`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryAndLanguageGroupPost
 * @summary 国家-语言列表（根据 大洲 分组）
 * @request POST:/sea_turtle_api/countryAndLanguage/group
 */
export function seaTurtleApiCountryAndLanguageGroupPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCountryAndLanguageGroupPostData, any>({
    url: baseUrl + `/sea_turtle_api/countryAndLanguage/group`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryCountryRegionPost
 * @summary 国家/地区列表
 * @request POST:/sea_turtle_api/country/countryRegion
 */
export function seaTurtleApiCountryCountryRegionPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCountryCountryRegionPostData, any>({
    url: baseUrl + `/sea_turtle_api/country/countryRegion`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiCountryCountryRegionAllPost
 * @summary 国家/地区列表（包含热门国家版本）
 * @request POST:/sea_turtle_api/country/countryRegionAll
 */
export function seaTurtleApiCountryCountryRegionAllPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCountryCountryRegionAllPostData, any>({
    url: baseUrl + `/sea_turtle_api/country/countryRegionAll`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiClauseInfoAllPost
 * @summary 条款信息
 * @request POST:/sea_turtle_api/clauseInfo/all
 */
export function seaTurtleApiClauseInfoAllPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiClauseInfoAllPostData, any>({
    url: baseUrl + `/sea_turtle_api/clauseInfo/all`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiClauseInfoAgreementTypeListPost
 * @summary 协议类型列表
 * @request POST:/sea_turtle_api/clauseInfo/agreementTypeList
 */
export function seaTurtleApiClauseInfoAgreementTypeListPost(
  root: SeaTurtleApiClauseInfoAgreementTypeListPostPayload = {},
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiClauseInfoAgreementTypeListPostData, any>({
    url: baseUrl + `/sea_turtle_api/clauseInfo/agreementTypeList`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiClauseInfoGetByTypePost
 * @summary 根据协议类型获取条款信息
 * @request POST:/sea_turtle_api/clauseInfo/getByType
 */
export function seaTurtleApiClauseInfoGetByTypePost(
  root: SeaTurtleApiClauseInfoGetByTypePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiClauseInfoGetByTypePostData, any>({
    url: baseUrl + `/sea_turtle_api/clauseInfo/getByType`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * No description
 *
 * @tags CommonApi
 * @name SeaTurtleApiClauseInfoGetByConditionPost
 * @summary 根据条件获取条款信息
 * @request POST:/sea_turtle_api/clauseInfo/getByCondition
 */
export function seaTurtleApiClauseInfoGetByConditionPost(
  root: SeaTurtleApiClauseInfoGetByConditionPostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiClauseInfoGetByConditionPostData, any>({
    url: baseUrl + `/sea_turtle_api/clauseInfo/getByCondition`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/**
 * @description 场景枚举：[    {        "scene": "login",        "sceneName": "登录"    },    {        "scene": "register",        "sceneName": "注册"    },    {        "scene": "updateContactPhone",        "sceneName": "更新联系电话"    },    {        "scene": "changeMobile",        "sceneName": "换绑手机号"    },    {        "scene": "resetPassword",        "sceneName": "重置密码"    },    {        "scene": "deleteAccount",        "sceneName": "删除账户"    }]
 *
 * @tags CommonApi
 * @name SeaTurtleApiGraphVerifyConfigGetClientSwitchByScenePost
 * @summary 根据场景获取客户端开关
 * @request POST:/sea_turtle_api/graphVerifyConfig/getClientSwitchByScene
 */
export function seaTurtleApiGraphVerifyConfigGetClientSwitchByScenePost(
  root: SeaTurtleApiGraphVerifyConfigGetClientSwitchByScenePostPayload,
  params: RequestExtraParams = {},
) {
  return request<SeaTurtleApiGraphVerifyConfigGetClientSwitchByScenePostData, any>({
    url: baseUrl + `/sea_turtle_api/graphVerifyConfig/getClientSwitchByScene`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}
